import { Box } from '@mui/material';
import { Videos } from '../../../../components/Media';
import { IUser } from '../../../../interfaces/user.interface';

interface VideosTabProps {
  user?: IUser;
}

const VideosTab = ({ user }: VideosTabProps) => {
  return (
    <Box id="videos">
      <Videos user={user} />
    </Box>
  );
};

export default VideosTab;
